const PRODUCT_TILE = [175, 250];
const THUMBNAIL_PRODUCT_MEDIA_ITEM = 48;

export {
    PRODUCT_TILE, THUMBNAIL_PRODUCT_MEDIA_ITEM
};
